module.exports = __webpack_public_path__ + "static/promo-bg-img-ee73d339e4fdd75dc3c50ed6a879275d.jpg";